module.exports = __webpack_public_path__ + "img/coinbankB10.d83206ff.jpg";